import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringOrUndefined',
    standalone: true,
})
export class StringOrUndefinedPipe implements PipeTransform {
    transform(value: unknown): string | undefined {
        if (typeof value === 'string') {
            return value;
        }
        if (value === null || value === undefined) {
            return undefined;
        }
        return String(value);
    }
}
